    async function getTechTalks(techTalkModel, techTalkBrand, ttype) {
        try {
            var keywords = '';
            var model = '';
            var brand = '';

            if (model && model.includes('PowerEdge')) {
                model = model.replace('PowerEdge', '');
            }
            if (model && model.includes('ProLiant')) {
                model = model.replace('ProLiant', '');
            }
            if (model != '') keywords = keywords + model + ',';
            if (brand != '') keywords = keywords + brand + ',';
            keywords = keywords + ttype;

            const snippets = await getBlogSnippets(keywords);
            
            if (snippets && snippets.length > 0) {
                hasTechTalks = true;
                displayTechTalks(snippets, model, brand, ttype);
            }
        } catch (error) {
            console.error('Error fetching TechTalks:', error);
        }
    }
    
    
    function showtextTab(textTabName) {
        // Hide all textTab contents
        document.querySelectorAll('.textTab-content').forEach(content => {
            content.classList.remove('active');
        });
        
        // Remove active class from all textTabs
        document.querySelectorAll('.textTab').forEach(textTab => {
            textTab.classList.remove('active');
        });
        
        // Show selected textTab content and mark textTab as active
        document.getElementById(textTabName + '-content').classList.add('active');
        event.target.classList.add('active');
    }
    
    function checkAndManageTextVisibility() {
        const techTalktextTab = document.querySelector('.textTab[onclick="showtextTab(\'techtalk\')"]');
        const documentationtextTab = document.getElementById('documentation-textTab');
        const textTabContainer = document.querySelector('.textTab-container');
        
        // Hide TechTalk textTab only if it has no content
        if (!hasTechTalks && techTalktextTab) {
            techTalktextTab.style.display = 'none';
        } else if (hasTechTalks && techTalktextTab) {
            techTalktextTab.style.display = 'block';
        }
        
        // Hide Documentation textTab only if it has no content
        if (!hasDocumentation && documentationtextTab) {
            documentationtextTab.style.display = 'none';
        } else if (hasDocumentation && documentationtextTab) {
            documentationtextTab.style.display = 'block';
        }
        
        // If neither has content, hide component
        if (!hasTechTalks && !hasDocumentation) {
            document.querySelector('.mentionedTechTalk').style.opacity = 0;
            return;
        }
        
        // Show the component since we have at least one type of content
        document.querySelector('.mentionedTechTalk').style.opacity = 1;
        
        // If only one textTab has content, show section title and hide textTabs
        if ((hasTechTalks && !hasDocumentation) || (!hasTechTalks && hasDocumentation)) {
            const titleContainer = document.querySelector('.techtalk-section-title-container');
            const titleElement = document.getElementById('techtalk-single-section-title');
            const textTabContainer = document.querySelector('.textTab-container');
            
            // Hide textTabs and show section title
            textTabContainer.style.display = 'none';
            titleContainer.style.display = 'block';
            
            // Show the appropriate content and set title
            if (hasTechTalks) {
                document.getElementById('techtalk-content').classList.add('active');
                document.getElementById('documentation-content').classList.remove('active');
                titleElement.textContent = 'TechTalk Mentions';
            } else {
                document.getElementById('documentation-content').classList.add('active');
                document.getElementById('techtalk-content').classList.remove('active');
                titleElement.textContent = 'Documentation';
            }
        } else {
            // Both have content, show textTabs normally
            document.querySelector('.techtalk-section-title-container').style.display = 'none';
            document.querySelector('.textTab-container').style.display = 'flex';
        }
    }

    async function getBlogSnippets(keywords) {
        try {
            const url = new URL('https://apiapi.ombligo.com/getBlogSnippets');
            url.searchParams.append('keywords', keywords);

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (response.ok) {
                const data = await response.json();
                return data;
            } else {
                console.error(`Error: ${response.status} ${response.statusText}`);
                return [];
            }
        } catch (error) {
            console.error('Error fetching blog snippets:', error);
            return [];
        }
    }
        
    
    
    function displayTechTalks(techTalks, model, brand, type) {
        const techTalksList = document.getElementById('techtalk-list');
        
        if (techTalks.length === 0) {
            techTalksList.innerHTML = '<div class="no-articles">No TechTalk mentions available for this product.</div>';
            return;
        }
        document.querySelector('.textTab-container').style.opacity = 1;
        document.querySelector('.mentionedTechTalk').style.opacity = 1;
        // Show only first 3 tech talks by default
        const limitedTechTalks = techTalks.slice(0, 3);
        
        // Apply highlighting to snippets
        limitedTechTalks.forEach(snippet => {
            snippet.snippet = snippet.snippet.replace(model, '<span class="bold highlight">' + model + '</span>');
            snippet.snippet = snippet.snippet.replace(brand, '<span class="bold highlight">' + brand + '</span>');
            snippet.snippet = snippet.snippet.replace(type, '<span class="bold highlight">' + type + '</span>');
        });
        
        techTalksList.innerHTML = limitedTechTalks.map(snippet => `
            <a href="https://techmikeny.com/blogs/techtalk/${snippet.handle}" target="_blank" class="mentionedTechTalk_item_container" style="text-decoration: none; color: inherit;" title="Read: ${snippet.title} - Opens in new tab">
                <svg class="external-link-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#0095ff">
                    <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h560v-280h80v280q0 33-23.5 56.5T760-120H200Zm188-212-56-56 372-372H560v-80h280v280h-80v-144L388-332Z"/>
                </svg>
                <div class="collection_article_modal_container"></div>
                <div class="collection_article_overlay"></div>
                <div class="MentionedTechTalk_text_container">
                    <div class="MentionedTechTalk_image_container">
                        <img 
                            class="MentionedTechTalk_article_card_img" 
                            src="${snippet.image}&width=300" 
                            alt="${snippet.title}"
                            onerror="imgNotFound(this)"
                        />
                    </div>
                    <div>
                        <div class="MentionedTechTalk_article_card_title_container">
                            <span class="MentionedTechTalk_article_card_title">${snippet.title}</span>
                        </div>
                        <div class="MentionedTechTalk_article_card_title_container">
                            <p class="MentionedTechTalk_article_card_snippet">${snippet.snippet}</p>
                        </div>
                    </div>
                </div>
            </a>
        `).join('');

        // Add "Show All TechTalks" button if there are more than 3
        if (techTalks.length > 3) {
            let showAllButton = document.createElement('button');
            showAllButton.textContent = "Show All TechTalk Mentions";
            showAllButton.style = "display: block; margin: 20px auto; padding: 10px 20px; background-color: #00243f; color: white; border: none; border-radius: 4px; cursor: pointer;";
            showAllButton.onclick = () => {
                // Limit to maximum 7 articles
                const limitedShowAll = techTalks.slice(0, 7);
                
                // Apply highlighting to limited snippets
                limitedShowAll.forEach(snippet => {
                    snippet.snippet = snippet.snippet.replace(model, '<span class="bold highlight">' + model + '</span>');
                    snippet.snippet = snippet.snippet.replace(brand, '<span class="bold highlight">' + brand + '</span>');
                    snippet.snippet = snippet.snippet.replace(type, '<span class="bold highlight">' + type + '</span>');
                });
                
                techTalksList.innerHTML = limitedShowAll.map(snippet => `
                    <a href="https://techmikeny.com/blogs/techtalk/${snippet.handle}" target="_blank" class="mentionedTechTalk_item_container" style="text-decoration: none; color: inherit;" title="Read: ${snippet.title} - Opens in new tab">
                        <svg class="external-link-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#0095ff">
                            <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h560v-280h80v280q0 33-23.5 56.5T760-120H200Zm188-212-56-56 372-372H560v-80h280v280h-80v-144L388-332Z"/>
                        </svg>
                        <div class="collection_article_modal_container"></div>
                        <div class="collection_article_overlay"></div>
                        <div class="MentionedTechTalk_text_container">
                            <div class="MentionedTechTalk_image_container">
                                <img 
                                    class="MentionedTechTalk_article_card_img" 
                                    src="${snippet.image}&width=300" 
                                    alt="${snippet.title}"
                                    onerror="imgNotFound(this)"
                                />
                            </div>
                            <div>
                                <div class="MentionedTechTalk_article_card_title_container">
                                    <span class="MentionedTechTalk_article_card_title">${snippet.title}</span>
                                </div>
                                <div class="MentionedTechTalk_article_card_title_container">
                                    <p class="MentionedTechTalk_article_card_snippet">${snippet.snippet}</p>
                                </div>
                            </div>
                        </div>
                    </a>
                `).join('');
                
                let readMoreButton = document.createElement('a');
                readMoreButton.href = 'https://techmikeny.com/blogs/techtalk';
                readMoreButton.target = '_blank';
                readMoreButton.title = 'Visit TechMikeNY TechTalk Blog - Opens in new tab';
                readMoreButton.innerHTML = 'Read More TechTalk Articles<svg class="" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#fff"><path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h560v-280h80v280q0 33-23.5 56.5T760-120H200Zm188-212-56-56 372-372H560v-80h280v280h-80v-144L388-332Z"/></svg>';
                readMoreButton.style = "display: flex; align-items:center; justify-content:center; gap:8px; margin: 20px auto; padding: 10px 20px; background-color: #0095ff; color: white; border: none; border-radius: 4px; cursor: pointer; text-decoration: none; text-align: center; width: fit-content; position: relative;";
                readMoreButton.onmouseover = () => { readMoreButton.style.backgroundColor = '#007acc'; };
                readMoreButton.onmouseout = () => { readMoreButton.style.backgroundColor = '#0095ff'; };
                
                techTalksList.appendChild(readMoreButton);
                showAllButton.style.display = 'none';
            };
            
            techTalksList.appendChild(showAllButton);
        }
    }
    
    async function getDocumentation(productSku) {
        try {
            const response = await fetch(`https://apiapi.ombligo.com/n_contentful/specific/ctoProductDescriptionAndDocumentation/productSku/${productSku}/`);
            const data = await response.json();
            
            if (data && data.items && data.items.length > 0 && data.items[0].fields.documentationLinks && data.items[0].fields.documentationLinks.length > 0) {
                hasDocumentation = true;
                displayDocumentation(data.items[0].fields.documentationLinks);
            }
        } catch (error) {
            console.error('Error fetching documentation:', error);
        }
    }
    
    async function displayDocumentation(documentationLinks) {
        const documentationList = document.getElementById('documentation-list');
        
        if (documentationLinks.length === 0) {
            documentationList.innerHTML = '<div class="no-articles">No documentation available for this product.</div>';
            return;
        }
        
        // Show only first 3 documentation links by default
        const limitedDocs = documentationLinks.slice(0, 3);
        
        // Fetch each documentation entry
        const docPromises = limitedDocs.map(async (link) => {
            try {
                const docResponse = await fetch(`https://apiapi.ombligo.com/n_contentful/entry/entries/${link.sys.id}/`);
                const docLink = await docResponse.json();
                return docLink;
            } catch (error) {
                console.error('Error fetching doc entry:', error);
                return null;
            }
        });
        
        const docs = await Promise.all(docPromises);
        const validDocs = docs.filter(doc => doc && doc.fields);
        
        documentationList.innerHTML = validDocs.map(docLink => `
            <a href="${docLink.fields.linkUrl}" target="_blank" class="mentionedTechTalk_item_container" style="text-decoration: none; color: inherit;" title="View Documentation: ${docLink.fields.title} - Opens in new tab">
                <svg class="external-link-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#0095ff">
                    <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h560v-280h80v280q0 33-23.5 56.5T760-120H200Zm188-212-56-56 372-372H560v-80h280v280h-80v-144L388-332Z"/>
                </svg>
                <div class="collection_article_modal_container"></div>
                <div class="collection_article_overlay"></div>
                <div class="MentionedTechTalk_text_container">
                    <div class="MentionedTechTalk_image_container">
                        <svg xmlns="http://www.w3.org/2000/svg" height="100px" viewBox="0 -960 960 960" width="100px" fill="#1b98dd">
                            <path d="M320-240h320v-80H320v80Zm0-160h320v-80H320v80ZM240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h320l240 240v480q0 33-23.5 56.5T720-80H240Zm280-520v-200H240v640h480v-440H520ZM240-800v200-200 640-640Z"/>
                        </svg>
                    </div>
                    <div>
                        <div class="MentionedTechTalk_article_card_title_container">
                            <span class="MentionedTechTalk_article_card_title">${docLink.fields.title}</span>
                        </div>
                        <div class="MentionedTechTalk_article_card_title_container">
                            <p class="MentionedTechTalk_article_card_snippet">Documentation resource for this product</p>
                        </div>
                    </div>
                </div>
            </a>
        `).join('');

        // Add "Show All Documentation" button if there are more than 3
        if (documentationLinks.length > 3) {
            let showAllButton = document.createElement('button');
            showAllButton.textContent = "Show All Documentation";
            showAllButton.style = "display: block; margin: 20px auto; padding: 10px 20px; background-color: #00243f; color: white; border: none; border-radius: 4px; cursor: pointer;";
            showAllButton.onclick = async () => {
                // Fetch all documentation entries
                const allDocPromises = documentationLinks.map(async (link) => {
                    try {
                        const docResponse = await fetch(`https://apiapi.ombligo.com/n_contentful/entry/entries/${link.sys.id}/`);
                        const docLink = await docResponse.json();
                        return docLink;
                    } catch (error) {
                        console.error('Error fetching doc entry:', error);
                        return null;
                    }
                });
                
                const allDocs = await Promise.all(allDocPromises);
                const allValidDocs = allDocs.filter(doc => doc && doc.fields);
                
                documentationList.innerHTML = allValidDocs.map(docLink => `
                    <a href="${docLink.fields.linkUrl}" target="_blank" class="mentionedTechTalk_item_container" style="text-decoration: none; color: inherit;" title="View Documentation: ${docLink.fields.title} - Opens in new tab">
                        <svg class="external-link-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#0095ff">
                            <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h560v-280h80v280q0 33-23.5 56.5T760-120H200Zm188-212-56-56 372-372H560v-80h280v280h-80v-144L388-332Z"/>
                        </svg>
                        <div class="collection_article_modal_container"></div>
                        <div class="collection_article_overlay"></div>
                        <div class="MentionedTechTalk_text_container">
                            <div class="MentionedTechTalk_image_container">
                                <svg xmlns="http://www.w3.org/2000/svg" height="100px" viewBox="0 -960 960 960" width="100px" fill="#1b98dd">
                                    <path d="M320-240h320v-80H320v80Zm0-160h320v-80H320v80ZM240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h320l240 240v480q0 33-23.5 56.5T720-80H240Zm280-520v-200H240v640h480v-440H520ZM240-800v200-200 640-640Z"/>
                                </svg>
                            </div>
                            <div>
                                <div class="MentionedTechTalk_article_card_title_container">
                                    <span class="MentionedTechTalk_article_card_title">${docLink.fields.title}</span>
                                </div>
                                <div class="MentionedTechTalk_article_card_title_container">
                                    <p class="MentionedTechTalk_article_card_snippet">Documentation resource for this product</p>
                                </div>
                            </div>
                        </div>
                    </a>
                `).join('');
                showAllButton.style.display = 'none';
            };
            
            documentationList.appendChild(showAllButton);
        }
    }

    // Function to check if FAQ component exists and is visible
    function checkLayoutAlignment() {
        const faqComponent = document.querySelector('.product-faqs');
        const techTalkComponent = document.querySelector('.mentionedTechTalk');
        const container = document.querySelector('.faq-tt');
        
        if (!container) return;
        
        const faqVisible = faqComponent && faqComponent.style.opacity !== '0' && window.getComputedStyle(faqComponent).opacity !== '0';
        const techTalkVisible = techTalkComponent && techTalkComponent.style.opacity !== '0';
        
        // If only one component is visible, add single-component class
        if ((faqVisible && !techTalkVisible) || (!faqVisible && techTalkVisible)) {
            container.classList.add('single-component');
        } else {
            container.classList.remove('single-component');
        }
    }
